// tslint:disable:max-line-length

import React from 'react';

export const ChartGroupedBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <rect y="15" width="16" height="1" />
      <rect y="4.4" width="3.1" height="9.6" />
      <rect x="4" y="1" width="3.1" height="13" />
      <rect x="9" y="6" width="3.1" height="8" />
      <rect x="12.9" width="3.1" height="14" />
    </svg>
  );
};
